import { Injectable } from '@angular/core';

export enum StorageNames{
    Settings = 'u1stSettings',
    IsActive = 'u1stIsActive',
    LoaderMode = 'loaderMode',
    MagnifyScale = 'MagnifyScale'
}

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    isLocalStorageSupported: boolean;

    u1stSettings: any = null;
    MagnifyScale: any = null;
    u1stIsActive: any = null;

    constructor(){
        this.isLocalStorageSupported = this.supportLocalStorage();
    }

    updateMemoryStorage(name, data){
        this[name] = data;
    }

    supportLocalStorage(): boolean{
        try {
            return window.localStorage !== undefined;
        } catch (error) {
            return false;
        }
    }

    clearAll(){
        if(!this.isLocalStorageSupported) return;

        window.localStorage.removeItem(StorageNames.Settings);
        window.localStorage.removeItem(StorageNames.IsActive);
    }

    set(name, data){
        this.isLocalStorageSupported && window.localStorage.setItem(name, JSON.stringify(data));
    }

    remove(name){
        this.isLocalStorageSupported && window.localStorage.removeItem(name);
    }

    get(name): string{
        return this.isLocalStorageSupported ? localStorage.getItem(name) : this[name];
    }

    getLoaderConfigValue(){

        try {
            const configValue = this.get(StorageNames.LoaderMode);
            if(!configValue) return;
            return unescape(configValue);
        } catch (error) {
            console.log("error while trying to get loader config value", error);
        }
        
    }
}
